import { render, staticRenderFns } from "./SerieMainInfo.vue?vue&type=template&id=8f1e6ae2&scoped=true&"
import script from "./SerieMainInfo.vue?vue&type=script&lang=js&"
export * from "./SerieMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./SerieMainInfo.vue?vue&type=style&index=0&id=8f1e6ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e6ae2",
  null
  
)

export default component.exports